import styled from "styled-components";

export const StyledFeatureItem = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 20%;
  text-align: center;
  transition: all 0.3s ease-in;
  opacity: 0;
  &.appear {
    opacity: 1 !important;
  }
  svg,
  h2,
  span {
    color: white;
  }
  span {
    font-size: 15px;
  }
  svg {
    height: 80px;
    width: 80px;
  }
  @media (max-width: 990px) {
    h2 {
      font-size: 20px;
    }
    span {
      font-size: 13px;
    }
  }

  @media (max-width: 886px) {
    h2 {
      font-size: 18px;
    }
    span {
      font-size: 12px;
    }
  }
  @media (max-width: 786px) {
    margin: 34px 0;
    width: 80%;
  }
`;
